/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Global } from '@emotion/react';
import { useState, useRef, useContext, useEffect } from 'react';
import {
  carouselStyling,
  widgetContainer,
  resetButtonStyle,
  carouselNavigation,
  sceneStyling,
  // carouselSlidePillarLabels,
  // labelStyling,
} from './styling';
import Arrow from '../Arrow';
import CarouselSlide from './CarouselSlide';
import { DetailsContext } from '../../context/detailsContext';
import { CarouselContext } from '../../context/carouselContext';
import { TopicContext } from '../../context/topicContext';
import PropTypes from 'prop-types';
// import ViewDetails from '../ViewDetails';
import ViewDetails from '../ViewDetailsV2';
import { useBreakpoint } from '../../context/breakpoint';
// import DotLabels from '../DotLabels';
import {
  durations,
  // easings
} from '../../constants';
import { Swiper, SwiperSlide } from 'swiper/react';
import Pillar from '../Pillar';
import { bp } from '../../utils/mediaQuery';
import { backgroundCarouselContainer } from './backgroundCarouselStyling';
import SwiperCore, { Virtual, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import './backgroundCarousel.css';
import { mq } from '../../utils/mediaQuery';
import { tracking, tagType } from '../../utils/tracking';
import { messages as text } from '../../messages';

SwiperCore.use([Virtual, Autoplay]);

const Carousel = ({ messages }) => {
  const breakpoints = useBreakpoint();

  const { setCurrentIndex, viewDetails } = useContext(DetailsContext);
  const { setIsRotating } = useContext(CarouselContext);
  const { isNavigationOpen } = useContext(TopicContext);
  const [isAutoplayState, setIsAutoplayState] = useState(true);
  const [isSwiperInit, setIsSwiperInit] = useState(false);
  const autoplayDelay = 1;

  // const [animateOut, setAnimateOut] = useState(false);

  const pillarHeightInPixel = breakpoints.sm || breakpoints.ls ? 200 : 300;

  const cellCount = messages.charts.length;

  const scaledWidthPixelSize =
    breakpoints.ls || breakpoints.sm ? (breakpoints.lg ? 28 : 21) : 28;
  const origWidthOfPillar = breakpoints.sm || breakpoints.ls ? 36 : 38;
  const scaledPillarHeightInPixel =
    breakpoints.ls || breakpoints.sm ? (breakpoints.lg ? 100 : 80) : 100;
  // const widthBetweenPillar = breakpoints.sm || breakpoints.ls ? 30 : 20;
  // const cellSize = origWidthOfPillar * 2 + widthBetweenPillar;

  const scaleSizeX = ((scaledWidthPixelSize / origWidthOfPillar) * 100) / 100;
  const scaleSizeY =
    ((scaledPillarHeightInPixel / pillarHeightInPixel) * 100) / 100;

  const detailsRef = {
    topLeftRef: useRef(null),
    bottomLeftRef: useRef(null),
  };

  let frontSwiperRef = useRef(undefined);
  let backSwiperRef = useRef(undefined);
  let sceneRef = useRef();

  const decrementIndex = () => {
    tracking(
      tagType.event,
      text.topicOverviewTitle.defaultMessage,
      'CLICK',
      'In-page click',
      `Click:Left`,
    );

    const newIndex =
      frontSwiperRef.current.realIndex - 1 === -1
        ? cellCount - 1
        : frontSwiperRef.current.realIndex - 1;
    setCurrentIndex(newIndex);
    setIsRotating(true);
    frontSwiperRef.current.slidePrev();
    backSwiperRef.current.slideNext();
  };

  const incrementIndex = () => {
    const newIndex =
      frontSwiperRef.current.realIndex + 1 === cellCount
        ? 0
        : frontSwiperRef.current.realIndex + 1;
    setCurrentIndex(newIndex);
    setIsRotating(true);

    tracking(
      tagType.event,
      text.topicOverviewTitle.defaultMessage,
      'CLICK',
      'In-page click',
      `Click:Right`,
    );

    frontSwiperRef.current.slideNext();
    backSwiperRef.current.slidePrev();
  };

  const chartsReversed = messages.charts.slice().reverse();

  useEffect(() => {
    if (viewDetails || isNavigationOpen) {
      stopAutoplay();
    } else {
      startAutoplay();
    }
  }, [viewDetails, isNavigationOpen]);

  function stopAutoplay() {
    setIsAutoplayState(false);
    frontSwiperRef.current.autoplay.stop();
  }

  function startAutoplay() {
    setIsAutoplayState(true);
    frontSwiperRef.current.autoplay.start();
  }

  // useEffect(() => {
  //   if (viewDetails) {
  //     setAnimateOut(true);
  //   } else {
  //     setTimeout(() => {
  //       setAnimateOut(false);
  //     }, durations.scalePillarDuration + 100);
  //   }
  // }, [viewDetails]);

  function onSlideChange(swiper) {
    if (isSwiperInit && isAutoplayState) {
      const newIndex = swiper.realIndex === cellCount ? 0 : swiper.realIndex;
      setCurrentIndex(newIndex);
      setIsRotating(true);

      backSwiperRef.current.slidePrev();
    } else {
      setIsSwiperInit(true);
    }
  }

  return (
    <div
      aria-label="Bar charts on looping animation until user taps or clicks the screen"
      role="img"
      className="ibm-widget-serverless-dv micro-service-widget"
      css={widgetContainer}>
      {/* <ViewDetails
        messages={messages}
        scaleSizeX={scaleSizeX}
        scaleSizeY={scaleSizeY}
        detailsRef={detailsRef}
        scaledWidthPixelSize={scaledWidthPixelSize}
        pillarHeightInPixel={pillarHeightInPixel}
      /> */}
      <ViewDetails messages={messages} hasScaledPillar={false} />
      <div
        css={[sceneStyling]}
        ref={sceneRef}
        style={{
          opacity: viewDetails ? 0.4 : 1,
          cursor: isAutoplayState ? 'pointer' : null,
        }}
        onClick={() => stopAutoplay()}>
        <Swiper
          slidesPerView="auto"
          loop
          containerModifierClass="backgroundCarousel"
          onSwiper={(swiper) => (backSwiperRef.current = swiper)}
          speed={
            isAutoplayState
              ? durations.carouselRotationDuration * 3
              : durations.carouselRotationDuration
          }
          initialSlide={5}
          simulateTouch={false}
          allowTouchMove={false}
          css={backgroundCarouselContainer}>
          {chartsReversed.map(({ overall, color }, index) => {
            return (
              <SwiperSlide key={index}>
                <div
                  css={{
                    display: 'flex',
                    height: '100%',
                    opacity: 0.7,
                    justifyContent: 'center',
                    [mq('xs')]: {
                      justifyContent: 'unset',
                    },
                  }}>
                  <Pillar
                    scaledWidthPixelSize={scaledWidthPixelSize}
                    totalPercent={overall}
                    color={color}
                    showPillarGradient={true}
                    backgroundPillar
                    blurValue={6}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div css={[carouselStyling]}>
          <Swiper
            autoplay={isAutoplayState ? { delay: autoplayDelay } : false}
            slidesPerView={2}
            simulateTouch={false}
            onSwiper={(swiper) => (frontSwiperRef.current = swiper)}
            loop
            centeredSlides
            allowTouchMove={false}
            centeredSlidesBounds={true}
            speed={
              isAutoplayState
                ? durations.carouselRotationDuration * 3
                : durations.carouselRotationDuration
            }
            watchSlidesVisibility
            css={{ height: '100%', overflow: 'visible!important' }}
            onSlideChange={(swiper) => onSlideChange(swiper)}
            breakpoints={{
              // when window width is >= 640px
              [bp['xs']]: {
                slidesPerView: 3,
              },
            }}>
            {messages.charts.map(({ overall, color, details }, index) => {
              return (
                <SwiperSlide key={index}>
                  {({ isActive, isNext, isPrev, isVisible }) => (
                    <CarouselSlide
                      index={index}
                      messages={messages}
                      pillarHeightInPixel={pillarHeightInPixel}
                      origWidthOfPillar={origWidthOfPillar}
                      overallPercent={overall}
                      details={details}
                      scaleSizeX={scaleSizeX}
                      scaleSizeY={scaleSizeY}
                      current={isActive}
                      isNext={isNext}
                      isPrev={isPrev}
                      sceneRef={sceneRef}
                      topLeftRef={detailsRef.topLeftRef}
                      bottomLeftRef={detailsRef.bottomLeftRef}
                      scaledWidthPixelSize={scaledWidthPixelSize}
                      isVisible={isVisible}
                      color={color}
                      currentSwiperTranslate={
                        frontSwiperRef.current &&
                        frontSwiperRef.current.translate
                      }
                    />
                  )}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
      {/* <div
        css={[
          carouselSlidePillarLabels,
          {
            width: cellSize,
            transition: `opacity ${
              viewDetails ? 100 : durations.viewDetailsDuration
            }ms ${easings.viewDetailsOpacity}`,
            opacity: animateOut ? 0 : 1,
          },
        ]}>
        <span css={labelStyling(origWidthOfPillar)}>
          Non-users
          <br />
          agree
        </span>
        <span css={labelStyling(origWidthOfPillar)}>
          Users
          <br />
          agree
        </span>
      </div> */}

      <button
        aria-label="Click to go to previous chart"
        onClick={decrementIndex}
        type="button"
        css={carouselNavigation('left')}
        style={{
          pointerEvents: viewDetails || isAutoplayState ? 'none' : 'auto',
          opacity: viewDetails || isAutoplayState ? 0 : 1,
        }}>
        <Arrow direction="left" />
      </button>
      <button
        aria-label="Click to go to next chart"
        onClick={incrementIndex}
        type="button"
        css={carouselNavigation('right')}
        style={{
          pointerEvents: viewDetails || isAutoplayState ? 'none' : 'auto',
          opacity: viewDetails || isAutoplayState ? 0 : 1,
        }}>
        <Arrow direction="right" />
      </button>

      {/* <DotLabels viewDetails={viewDetails} /> */}
      <Global
        styles={{
          // '@font-face': {
          //   fontFamily: 'ibm-plex-sans',
          //   src: `url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-regular.woff2)
          //   format("woff2"),
          //   url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-regular.woff)
          //   format("woff")`,
          //   fontWeight: 400,
          //   fontStyle: 'normal',
          // },
          // // eslint-disable-next-line no-dupe-keys
          // '@font-face': {
          //   fontFamily: 'ibm-plex-sans',
          //   src: `url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-medium.woff2)
          //   format("woff2"),
          //   url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-medium.woff)
          //   format("woff")`,
          //   fontWeight: 500,
          //   fontStyle: 'normal',
          // },
          // // eslint-disable-next-line no-dupe-keys
          // '@font-face': {
          //   fontFamily: 'ibm-plex-sans',
          //   src: `url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-light.woff2)
          //       format("woff2"),
          //     url(https://1.www.s81c.com/common/fonts/plex/v1/ibmplexsans-light.woff)
          //       format("woff")`,
          //   fontWeight: 300,
          //   fontStyle: 'normal',
          // },

          button: resetButtonStyle,
        }}
      />
    </div>
  );
};

Carousel.displayName = 'Carousel';

Carousel.propTypes = {
  messages: PropTypes.object,
};

export default Carousel;
